module.exports = __webpack_public_path__ + "img/siteError.13829b0b.png";